import { defineMessages } from 'react-intl';

export const notFoundMessageDefinitions = defineMessages({
  resourceDoesNotExist: {
    id: 'notFound.resourceDoesNotExist',
    defaultMessage:
      'The resource you are trying to reach does not exist, has been moved or could not be found.',
  },
  homePageButton: {
    id: 'notFound.homePageButton',
    defaultMessage: 'Home page',
  },
});
